import React, { Component } from "react";
import _ from "i18n";
import ExtraSlidesContentPage from "../ExtraSlides/ExtraSlidesContentPage";
import { connect } from "react-redux";
import { TTPReactModal } from "../Common/Modal/TTPReactModal";

class ExtraSlidesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      loading: false
    };
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      visible: true
    });
  }
  /*
  handleOk = (visible = false) => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: !visible });
    }, 3000);
  };*/

  handleCancel = () => {
    this.setState({ visible: false });
    this.props.onCancel();
  };

  render() {
    const { onClickUse } = this.props;
    return (
      <TTPReactModal
        title={_("chooseExtraSLide")}
        isOpen={this.state.visible}
        //inProcess={this.state.loading}
        // onConfirm={this.handleOk}
        onCancel={this.handleCancel}
        width={1100}
        extraSlideModal={true}
      >
        <ExtraSlidesContentPage handleUseExraSilde={onClickUse} />
      </TTPReactModal>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  extraSlideUsable: state.preparePresentation.extraSlideUsable
});

export default connect(mapStateToProps)(ExtraSlidesModal);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/ExtraSlidesModal.js